import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const classicProjectSettingsDetailsRoute: InvariantRoute = {
	name: 'classic-software-details',
	path: '/jira/software/c/projects/:projectKey/settings/details',
	exact: true,
};
